export const FETCH_NEWSLETTERS_REQUEST = 'newsletter/FETCH_NEWSLETTERS_REQUEST';
export const FETCH_NEWSLETTERS_SUCCESS = 'newsletter/FETCH_NEWSLETTERS_SUCCESS';
export const FETCH_NEWSLETTERS_FAILURE = 'newsletter/FETCH_NEWSLETTERS_FAILURE';

export const FETCH_TARGETS_BY_NEWSLETTER_REQUEST = 'newsletter/FETCH_TARGETS_BY_NEWSLETTER_REQUEST';
export const FETCH_TARGETS_BY_NEWSLETTER_SUCCESS = 'newsletter/FETCH_TARGETS_BY_NEWSLETTER_SUCCESS';
export const FETCH_TARGETS_BY_NEWSLETTER_FAILURE = 'newsletter/FETCH_TARGETS_BY_NEWSLETTER_FAILURE';

export const DELETE_NEWSLETTERS_REQUEST = 'newsletter/DELETE_NEWSLETTERS_REQUEST';
export const DELETE_NEWSLETTERS_SUCCESS = 'newsletter/DELETE_NEWSLETTERS_SUCCESS';
export const DELETE_NEWSLETTERS_FAILURE = 'newsletter/DELETE_NEWSLETTERS_FAILURE';

export const DELETE_NEWSLETTER_FILE_SUCCESS = 'newsletter/DELETE_NEWSLETTER_FILE_SUCCESS';
export const DELETE_NEWSLETTER_FILE_FAILURE = 'newsletter/DELETE_NEWSLETTER_FILE_FAILURE';

export const INIT_DELETION_TASK = 'newsletter/INIT_DELETION_TASK';

export const CLEAR_DELETION_TASK_ERROR = 'newsletter/CLEAR_DELETION_TASK_ERROR';

export const UPDATE_NEWSLETTERS = 'newsletter/UPDATE_NEWSLETTERS';

export const INIT_NEWSLETTERS = 'newsletter/INIT_NEWSLETTERS';

export const CLEAR_TARGETS_BY_NEWSLETTER_ERROR = 'newsletter/CLEAR_TARGETS_BY_NEWSLETTER_ERROR';

export const INIT_TARGETS_BY_NEWSLETTER = 'newsletter/INIT_TARGETS_BY_NEWSLETTER';

export const fetchNewslettersRequest = (payload = {}) => ({
  type: FETCH_NEWSLETTERS_REQUEST,
  payload,
});
export const fetchNewslettersSuccess = (payload = {}) => ({
  type: FETCH_NEWSLETTERS_SUCCESS,
  payload,
});
export const fetchNewslettersFailure = (payload = {}) => ({
  type: FETCH_NEWSLETTERS_FAILURE,
  payload,
});

export const fetchTargetsByNewsletterRequest = (payload = {}) => ({
  type: FETCH_TARGETS_BY_NEWSLETTER_REQUEST,
  payload,
});
export const fetchTargetsByNewsletterSuccess = (payload = {}) => ({
  type: FETCH_TARGETS_BY_NEWSLETTER_SUCCESS,
  payload,
});
export const fetchTargetsByNewsletterFailure = (payload = {}) => ({
  type: FETCH_TARGETS_BY_NEWSLETTER_FAILURE,
  payload,
});

export const deleteNewslettersRequest = (payload = {}) => ({
  type: DELETE_NEWSLETTERS_REQUEST,
  payload,
});
export const deleteNewslettersSuccess = (payload = {}) => ({
  type: DELETE_NEWSLETTERS_SUCCESS,
  payload,
});
export const deleteNewslettersFailure = (payload = {}) => ({
  type: DELETE_NEWSLETTERS_FAILURE,
  payload,
});

export const deleteNewsletterFileSuccess = (payload = {}) => ({
  type: DELETE_NEWSLETTER_FILE_SUCCESS,
  payload,
});
export const deleteNewsletterFileFailure = (payload = {}) => ({
  type: DELETE_NEWSLETTER_FILE_FAILURE,
  payload,
});

export const initDeletionTask = (payload = {}) => ({
  type: INIT_DELETION_TASK,
  payload,
});

export const clearDeletionTaskError = (payload = {}) => ({
  type: CLEAR_DELETION_TASK_ERROR,
  payload,
});

export const updateNewsletters = (payload = {}) => ({
  type: UPDATE_NEWSLETTERS,
  payload,
});

export const initNewsletters = (payload = {}) => ({
  type: INIT_NEWSLETTERS,
  payload,
});

export const clearTargetsByNewsletterError = (payload = {}) => ({
  type: CLEAR_TARGETS_BY_NEWSLETTER_ERROR,
  payload,
});

export const initTargetsByNewsletter = (payload = {}) => ({
  type: INIT_TARGETS_BY_NEWSLETTER,
  payload,
});
